export default __webpack_public_path__ + "static/media/kal-bhairav-temple.b4afb0f4.jpg";